<template>
  <div class="recoverpwd__form">
    <span>{{ $t('recoverpwd.title') }}</span>
    <div class="recoverpwd__form__col recover__form__msg" v-if="recoveryUserPwdStatus === RecoverUserPwdRequestStatus.WithoutStatus">
      <span>{{ $t('recoverpwd.title2') }}</span>
      <div>
        <label>E-mail:</label>
        <!--        <input type="email" name="email" v-model="email" placeholder="Insert your e-mail"/>-->
        <FieldInput
            name="username"
            type="email"
            v-model="email"
        />
      </div>
      <div class="recoverpwd__form__button">
        <button @click="Cancel" value="Cancel">{{ $t('menu.cancel') }}</button>
        <button @click="RecoverUserPwd" :disabled="!isValid" value="Go">{{ $t('menu.send') }}</button>
      </div>
    </div>
    <div class="recover__form__msg recoverpwd__form__button" v-if="recoveryUserPwdStatus === RecoverUserPwdRequestStatus.OK"
    style="align-items: center;justify-content: space-evenly">
      <p>{{ $t('recoverpwd.postmsg') }}</p>
      <button @click="GoLogin">Login</button>
    </div>
    <div class="recover__form__msg recoverpwd__form__button" v-if="recoveryUserPwdStatus === RecoverUserPwdRequestStatus.Error"
         style="align-items: center;justify-content: space-evenly">
      <p>{{ $t('recoverpwd.errormsg') }}</p>
      <button @click="Retry">{{ $t('menu.retry') }}</button>
    </div>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, ref} from "vue";
import {LoginUserFormStatus, RecoverUserPwdRequestStatus, UserEmail} from "@/types/User";
import APIDataServices from "@/services/APIDataServices";
import ResponseData from "@/types/ResponseData";
import * as Yup from "yup";
import {useForm} from "vee-validate";
import FieldInput from "@/components/UI/FieldInput.vue";
import {useStore} from "vuex";

export default defineComponent({
  name: "RecoverUserPwdForm",
  components: {
    FieldInput
  },
  setup() {

    const store = useStore();

    const email = ref();
    const recoveryUserPwdStatus = ref(RecoverUserPwdRequestStatus.WithoutStatus);

    const Retry = () => {
      email.value = null;
      recoveryUserPwdStatus.value = RecoverUserPwdRequestStatus.WithoutStatus;
    };

    const GoLogin = () => {
      Cancel();
    };

    const Cancel = () => {
      store.commit("setLoginUserFormStatus", LoginUserFormStatus.Login)
    };

    const RecoverUserPwd = () => {
      if (email.value != undefined && email.value != '') {
        const userEmail: UserEmail = {email: email.value};
        APIDataServices.recoveryUserPwd(userEmail)
            .then((response: ResponseData) => {
              // console.log('login response: ' + JSON.stringify(response.data));
              // recoveryUserPwdStatus.value = response.data ? RecoverUserPwdRequestStatus.OK : RecoverUserPwdRequestStatus.Error;
              recoveryUserPwdStatus.value = response.data === '' ? RecoverUserPwdRequestStatus.OK : RecoverUserPwdRequestStatus.Error;
            })
            .catch((e: Error) => {
              // console.log(e);
              recoveryUserPwdStatus.value = RecoverUserPwdRequestStatus.Error;
            });
      }
    };

    const schema = Yup.object().shape({
      username: Yup.string().email().required(),
    }) as any;

    const {meta, values} = useForm({
      validationSchema: schema
    });

    const isValid = computed(() => meta.value.valid);

    return {
      RecoverUserPwd,
      Retry,
      Cancel,
      GoLogin,
      email,
      recoveryUserPwdStatus,
      RecoverUserPwdRequestStatus,
      isValid,
    }
  }
});
</script>

<style scoped>

.recoverpwd__form {
  margin-left: auto;
  margin-right: auto;
  width: 95%;
}

.recoverpwd__form__col div {
  margin-top: 2rem;
}

.recoverpwd__form__button {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.recoverpwd__form__button button {
  font-weight: bold;
}

.recover__form__msg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  height: 22.5rem;
}

.recoverpwd__form > span {
  font-size: 2rem;
}

</style>
<style>
.recoverpwd__form__col div input {
  width: 25rem;
  margin-left: 1rem;
}
</style>
